export class GameStrategy
{
    protected running:boolean = false;
    isApplicable(gameState: any): boolean {
        throw new Error('must override in subclass');
    }

    execute(gameState: any): void {
        this.running = true;
    }

    disable(): void {
        this.running = false;
    }
}
